export const NOTIFICATION_TYPE_PROMOTION = 'promotion';
export const NOTIFICATION_TYPE_SEARCHING = 'searching';
export const NOTIFICATION_TYPE_PICKING = 'picking';



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/notifications.js